"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountType = exports.UINT256_MAX = exports.RAD = exports.RAY = exports.WAD = exports.WEI = void 0;

var _bignumber = _interopRequireDefault(require("bignumber.js"));

var WEI = new _bignumber.default('1e18');
exports.WEI = WEI;
var WAD = new _bignumber.default('1e18');
exports.WAD = WAD;
var RAY = new _bignumber.default('1e27');
exports.RAY = RAY;
var RAD = new _bignumber.default('1e45');
exports.RAD = RAD;
var UINT256_MAX = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';
exports.UINT256_MAX = UINT256_MAX;
var AccountType = {
  PROVIDER: 'provider',
  PRIVATE_KEY: 'privateKey',
  BROWSER: 'browser'
};
exports.AccountType = AccountType;